export default __webpack_public_path__ + "static/Lumberjack-6afd091797962f16899db47ed1b9a529.png";